/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
export default {
  beforeMount(el, binding) {
    const handler = (e) => {
      e.stopPropagation()

      if (!el.contains(e.target)) {
        binding.value(e)
      }
    }

    el.__vueClickOutside__ = handler

    document.addEventListener('click', handler)
  },

  unmounted(el) {
    document.removeEventListener('click', el.__vueClickOutside__)
  },
}
